declare global {
  interface Window {
    twentythree?: {
      environment?: 'production' | 'staging' | undefined
      release?: string
    }
  }
}

const getEnvironmentSettings = () => {
  const coreSettings = window.twentythree ?? {}
  return {
    environment: coreSettings.environment ?? 'development',
    release: coreSettings.release ?? 'local',
  }
}

const ENV_SETTINGS = getEnvironmentSettings()

export { ENV_SETTINGS }
